interface EpisodeListProps {
  total: number;
  current: number;
  onChange: (episode: number) => void;
}

export default function EpisodeList({ total, current, onChange }: EpisodeListProps) {
  const episodes = Array.from({ length: total }, (_, i) => i + 1);

  return (
    <div>
      <div className="mb-3 flex items-center justify-between">
        <h3 className="flex items-center gap-2 font-heading text-base font-bold text-foreground-950">
          <i className="ri-play-list-2-line text-primary-600" />
          剧集列表
        </h3>
        <span className="text-xs text-foreground-500">全 {total} 集</span>
      </div>
      <div className="grid max-h-64 grid-cols-5 gap-2 overflow-y-auto pr-1 sm:grid-cols-6 md:grid-cols-8 lg:grid-cols-10">
        {episodes.map((ep) => (
          <button
            key={ep}
            type="button"
            onClick={() => onChange(ep)}
            aria-current={ep === current}
            className={`aspect-square rounded-md text-sm font-medium transition-colors ${
              ep === current
                ? "bg-primary-500 text-background-50"
                : "border border-background-200 bg-background-50 text-foreground-600 hover:border-primary-300 hover:text-primary-700"
            }`}
          >
            {ep}
          </button>
        ))}
      </div>
    </div>
  );
}